module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-pages-container"
  }, [(_vm.showScreen) ? _c('div', {
    staticClass: "block-back-to-segment"
  }, [_c('div', {
    staticClass: "backbtn-segment",
    on: {
      "click": _vm.closeSegmentCards
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Retour\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "current-segment-block"
  }, [_c('div', {
    staticClass: "custom-folder xs small darckblue"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentSegment.title))])])])]) : _vm._e(), _vm._v(" "), (_vm.show_generic_display == 1 && _vm.all.length > 0 && !_vm.showScreen) ? _c('div', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('show_generic_action'),
      expression: "'show_generic_action'"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.withGeneric),
      expression: "withGeneric"
    }],
    staticClass: "custom-btn-generic",
    class: {
      filled: _vm.startGeneric
    },
    on: {
      "click": function($event) {
        return _vm.videoGenerique('debut')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 511.816 511.816"
    },
    attrs: {
      "version": "1.1",
      "width": "25px",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 511.816 511.816",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#ffffff"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.949,298.483v160c0,29.419,23.936,53.333,53.333,53.333h384c29.419,0,53.333-23.915,53.333-53.333v-160H20.949z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "252.757,48.776 172.927,67.72 239.807,166.131 326.271,146.462 \t\t"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "150.741,72.99 64.703,93.384 130.879,190.878 217.471,171.187 \t\t"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M511.274,93.086l-18.155-68.864c-4.181-16.747-21.333-27.285-38.251-23.424l-71.68,17.024l68.011,100.267l52.117-11.861\n\t\t\tc2.837-0.64,5.269-2.411,6.763-4.885S511.999,95.902,511.274,93.086z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "360.981,23.091 275.413,43.4 349.055,141.299 428.863,123.144 \t\t"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128.447,191.838 94.314,277.15 178.005,277.15 212.138,191.838 \t\t"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "235.114,191.838 200.981,277.15 284.671,277.15 318.805,191.838 \t\t"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M500.949,191.838h-52.501l-34.133,85.333h97.301v-74.667C511.615,196.595,506.858,191.838,500.949,191.838z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "341.781,191.838 307.647,277.15 391.317,277.15 425.471,191.838 \t\t"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.517,98.675l-17.387,4.117c-8.469,1.92-15.637,7.061-20.181,14.443c-4.544,7.403-5.888,16.107-3.776,24.533\n\t\t\tl19.776,78.165v57.216h50.389l32.021-80.021l5.205-1.173L42.517,98.675z"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "custom-button-navigation--left",
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, -1)
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "20px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#939ea7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "slides-panel row",
    attrs: {
      "id": "div-draggable"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "ps",
    staticClass: "scroll-area",
    attrs: {
      "id": "ps-slide-wrapper",
      "use-both-wheel-axes": true
    },
    on: {
      "ps-scroll-x": _vm.removeSmoothing
    }
  }, [_c('div', {
    staticClass: "row__inner",
    on: {
      "mousewheel": _vm.scrollHorizontally
    }
  }, [_c('draggable', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "id": "draggable-wrapper",
      "move": _vm.dragSlide
    },
    on: {
      "end": _vm.reorder,
      "start": _vm.getList
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, [_vm._l((_vm.all), function(slide, index) {
    return _c('div', {
      key: 'list-complete-c-' + index,
      staticClass: "card-wrapper",
      class: {
        extended: slide.isExtended
      },
      attrs: {
        "data-uid": slide.uid
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isExtendedSlides),
        expression: "!isExtendedSlides"
      }],
      staticClass: "transition-icon-wrapper"
    }, [_c('b-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.show_video_intro),
        expression: "show_video_intro"
      }],
      staticClass: "transition-btn",
      class: {
        active: _vm.hasStartGeneric(slide)
      },
      on: {
        "click": function($event) {
          return _vm.videoGenerique('intro', index)
        }
      }
    }, [_c('i', {
      staticClass: "icon-film-strip"
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isExtendedSlides),
        expression: "!isExtendedSlides"
      }],
      staticClass: "index-segment"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('custom-panel-card', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isExtendedSlides),
        expression: "!isExtendedSlides"
      }],
      attrs: {
        "segmenOneScreen": _vm.oneScreen,
        "typecard": _vm.typecard,
        "index": index,
        "slide": slide,
        "isSelected": slide.uid === _vm.currentSegment.uid,
        "removable": _vm.all.length > 1,
        "showVideoIntro": {},
        "is-segment-card": true
      },
      on: {
        "selected": function($event) {
          return _vm.selectSegment(slide)
        },
        "duplicated": function($event) {
          return _vm.handleDuplicateSegment(slide, index)
        },
        "insertSegment": function($event) {
          return _vm.handleInsertSegment(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExtendedSlides && _vm.currentSegment.uid == slide.uid),
        expression: "isExtendedSlides && currentSegment.uid == slide.uid"
      }],
      staticClass: "inner-slides-wrapper",
      class: {
        extended: slide.isExtended
      },
      style: (_vm.calculateWidth(slide))
    }, [_c('draggable', {
      key: _vm.segmentKey,
      staticClass: "inner-slides-container",
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "id": "nested-draggable-wrapper"
      },
      on: {
        "end": function($event) {
          return _vm.reorderSlides($event, index)
        }
      },
      model: {
        value: (_vm.lists[index]),
        callback: function($$v) {
          _vm.$set(_vm.lists, index, $$v)
        },
        expression: "lists[index]"
      }
    }, _vm._l((_vm.getScreens(slide)), function(slideScreen, i) {
      return _c('div', {
        key: i,
        staticClass: "slides-transitions-wrapper"
      }, [_c('div', {
        staticClass: "index-screen"
      }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('custom-panel-card', {
        attrs: {
          "typecard": 'screen',
          "index": i,
          "segment": slide,
          "slide": slideScreen,
          "isSelected": slideScreen.uid === _vm.currentSlide.uid
        },
        on: {
          "selected": function($event) {
            return _vm.selectSlide(slide, slideScreen)
          },
          "duplicated": function($event) {
            return _vm.handleDuplicateSlideInsideSegment(slide, slideScreen, index, i)
          }
        }
      })], 1)
    }), 0)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.oneScreen),
      expression: "oneScreen"
    }],
    staticClass: "folder-slide-add",
    on: {
      "click": function($event) {
        return _vm.handleInsertSegment(_vm.lengthSegmentToAdd)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), (!_vm.isExtendedSlides && !_vm.oneScreen) ? _c('div', {
    staticClass: "custom-folder small blue floder-add-segment ",
    on: {
      "click": function($event) {
        return _vm.handleInsertSegment(_vm.lengthSegmentToAdd)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e(), _vm._v(" "), (_vm.isExtendedSlides && !_vm.oneScreen) ? _c('div', {
    staticClass: "folder-slide-add",
    on: {
      "click": function($event) {
        return _vm.handleAppendSlide(_vm.currentSegment)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e()], 2)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "custom-button-navigation--right",
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, 1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "20px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#939ea7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
    }
  })])])]), _vm._v(" "), (_vm.show_generic_display == 1 && _vm.all.length > 0 && !_vm.showScreen) ? _c('div', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('show_generic_action'),
      expression: "'show_generic_action'"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.withGeneric),
      expression: "withGeneric"
    }],
    staticClass: "custom-btn-generic",
    class: {
      filled: _vm.finishGeneric
    },
    on: {
      "click": function($event) {
        return _vm.videoGenerique('fin')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "margin-top": "45px"
    },
    attrs: {
      "height": "30px",
      "viewBox": "0 0 58 58",
      "width": "30px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#ffffff",
      "fill-rule": "nonzero",
      "transform": "translate(0 -1)"
    }
  }, [_c('path', {
    attrs: {
      "d": "m14.678 58.9507 1.0678-.2984c1.0270794-.287091 1.6269982-1.3523947 1.34-2.3795l-12.2083-43.6888c-.17227193-.6165569-.58242107-1.139423-1.14021438-1.4535673-.5577933-.3141444-1.21753647-.3938324-1.83408562-.2215327l-.1379.0385c-1.28397381.3587434-2.0340279 1.6904218-1.6753 2.9744l12.2086 43.6888c.2870014 1.0271063 1.3522895 1.6270863 2.3794 1.3401z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Shape",
      "d": "m57.67 28.42c-3.8715209-1.930437-7.4530885-4.3944478-10.64-7.32-.2678864-.245221-.3726619-.6216366-.27-.97 1.579074-5.9738125 2.7517572-12.04771023 3.51-18.18.12-1.02-.43-1.32-1.01-.62-11.38 13.61-31.07-2.49-42.79 9.88.14070884.2634479.25140182.5418575.33.83l7.92 28.36c11.74-12.22 31.36 3.78 42.72-9.8.58-.7.69-1.98.23-2.18z"
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-502b848a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/CustomPanelPages.vue
// module id = 833
// module chunks = 1 3